import { BarChart3, FileText, Layers, MessagesSquare } from "lucide-react";
import { WHY_US } from "@/site-data";
import { Reveal, Eyebrow } from "./Reveal";

const ICONS = { BarChart3, FileText, Layers, MessagesSquare };

export default function NedenBiz() {
  return (
    <section id="neden-biz" className="relative py-24 md:py-32">
      <div className="absolute inset-0 bg-[#122263]/40" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <Eyebrow>Neden Biz</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 max-w-2xl font-syne text-3xl font-bold tracking-tight md:text-5xl">
            Büyümeniz İçin <span className="text-[#1E7FFF]">Fark Yaratan</span> Yaklaşım.
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {WHY_US.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <Reveal key={item.title} delay={0.08 * i} className="h-full">
                <div
                  data-testid={`why-us-card-${i}`}
                  className="group h-full rounded-2xl border border-[#2E4390] bg-[#0D1B5E]/80 p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-[#1E7FFF]"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#1E7FFF]/15 text-[#5CA3FF] transition-all duration-300 group-hover:bg-[#1E7FFF] group-hover:text-white">
                    <Icon size={22} />
                  </span>
                  <h3 className="mt-5 font-syne text-lg font-bold">{item.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#B9C4E8]">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
